import React from 'react';

/**
 * Displays a group of tokens. This is similar to the AWS-UI
 * token group (https://polaris.a2z.com/components/awsui-token-group)
 * except this version doesn't have the cross sign ('X') in the upper
 * right corner.
 *
 */
export class TokenGroupDisplay extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { items } = this.props;

    return items.map((item) => {
      return (
        <div className="awsui-token" key={item.label} style={{ marginRight: '0.5em', marginBottom: '0.5em' }}>
          <div className="awsui-select-option">
            <div className="awsui-select-option-content">
              <div className="awsui-select-option-label-content">
                <span className="awsui-select-option-label">{item.label}</span>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/common/token_group_display.jsx